import React, {useEffect, useState, } from "react";
import { Space } from 'antd';
import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "../stateManagement/actions/auth";
import UsersList from "../components/sections/usersList";

const UsersPage = () =>{

    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [reloader, setReloader] = useState(false);
    const {publisherView} = useSelector((state) => state.reportReducer);

     //Reload when updates
    const forceRerender = () => setReloader(prevState => !prevState);

    useEffect(() => {
        dispatch(getUsers(setData))
    }, [dispatch, reloader]);

    return(<>
        <h2>{`Users list (${publisherView} view):`}</h2>
        <Space>
            <UsersList list={data} reloadData={forceRerender}/>
        </Space>
    </>)
}

export default UsersPage;